import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { RadioOption } from '@/common/types';
import { API_URL, IElectronicFundingDto } from '@/dtos';

export default () => {
  const { isLoading, isSuccess, isError, data, error } = useQuery(
    ['getElectronicFundingReplenishments'],
    () => api.get<IElectronicFundingDto[]>(API_URL.ENUMS_ELECTRONIC_FUNDING_REPLENISHMENTS)
  );

  const formatedData = useMemo<RadioOption[]>(() => {
    const list = data?.data || [];
    return list.map(
      (listItem): RadioOption => ({
        label: listItem?.description || '',
        value: listItem?.name || '',
      })
    );
  }, [data]);

  return {
    data: formatedData || [],
    error,
    isError,
    isLoading,
    isSuccess,
  };
};
